









































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { qualityList, qualityCollection, createScoreGroup, queryAllMember, departments } from '@/api/quality';
import selectMember from '@/components/project/selectMember.vue';
import moment from 'moment';
import { hasPermission } from '@/utils/utils';
// import { meetingCategory } from '@/utils/project';
import { roleMap } from '@/utils/meeting';
import { mapGetters } from 'vuex';

// const roleMap = {
//   1: 'FDD',
//   2: 'LDD',
//   4: 'HDD',
//   8: 'ITDD',
//   16: '财务（人民币）',
//   32: '财务（美元）',
//   64: 'PDD',
//   128: '揽星',
//   256: 'DM',
//   512: 'DL'
// };

const contributeLevalMap = {
  1: '看得见',
  2: '看的清',
  3: '投的进'
};

const meetingCategoryMap = {
  1: 'Early',
  2: 'Early Growth',
  3: 'Growth',
  5: 'Late Growth',
  6: 'Seed'
};

const meetingGoalMap = {
  2: 'Onepager',
  3: 'DD Memo(Pre-TS)',
  4: 'DD Memo(Pre-SPA)',
  5: 'DD Memo(Pre交割)',
  7: 'PreLoan'
};

@Component({
  components: { selectMember },
  computed: { ...mapGetters(['userInfo']) }
})
class QualityManage extends Vue {
  userInfo: any;
  filterNow: number = 1;
  columns: any[] = [];
  data: any[] = [];
  keyword: string = '';
  total: number = 0;
  pageSize: number = 10;
  roleMap: object = roleMap;
  contributeLevalMap: object = contributeLevalMap;
  loading: boolean = false;
  showModal: boolean = false;
  companyObj: object = {};
  scoreList: any[] = [];
  page: number = 1;
  meetingCategoryMap: object = meetingCategoryMap;
  meetingGoalMap: object = meetingGoalMap;
  totalList: any[] = [];
  permissions: object = {
    hasScoreGroup: false,
    hasUrge: false,
    hasCreateQuality: false
  };
  departmentMap: object = {};
  appId: string = '';

  created() {
    const { permissions: queue } = this.userInfo || {};
    this.permissions['hasScoreGroup'] = hasPermission(queue, '/systemSetting/manage/projectQuality/createScoreGroup');
    this.permissions['hasUrge'] = hasPermission(queue, '/systemSetting/manage/projectQuality/urgeQuality');
    this.permissions['hasCreateQuality'] = hasPermission(queue, '/systemSetting/manage/projectQuality/createQuality');
    this.getList();
    if (window.location.host === 'hubble.sourcecodecap.com:8050') {
      this.appId = 'cli_a2944d3d4c22900e';
    } else if (/hubble/.test(window.location.host)) {
      this.appId = 'cli_9f8f27b375fbd00c';
    } else if (/pretianchi/.test(window.location.host)) {
      this.appId = 'cli_a13c47f49878900b';
    } else if (/tianchi/.test(window.location.host)) {
      this.appId = 'cli_9e32766f10b9900e';
    } else {
      this.appId = 'cli_9f8f27b375fbd00c';
    }
  }

  toPath(pathTo) {
    this.$router.push({ path: '/systemSetting/manage/projectQuality/' + pathTo });
  }

  async getList() {
    try {
      this.data = [];
      let res = await qualityList({
        page: this.page,
        pageSize: this.pageSize,
        status: this.filterNow,
        companyName: this.keyword,
        id: this.$route.query.id
      });
      if (res.code === 200) {
        let list = res.data.list || [];
        this.total = res.data.total;
        this.getData(list);
        this.getColumns();
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getDepartments() {
    try {
      let res = await departments();
      if (res.code === 200) {
        res.data.forEach(_ => {
          this.departmentMap[_.code] = _.leaderName;
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  getData(list) {
    list.forEach(e => {
      if (e.contributorList) {
        e.contributorList.forEach((item, index) => {
          this.data.push({
            ...e,
            // id: item.id,
            scorers: item.scorers,
            companyRowSpan: index === 0 ? e.contributorList.length : 0,
            nickname: item.nickname,
            role: item.role,
            leaderEvaluate: item.leaderEvaluate,
            contributeLevel: item.contributeLevel,
            contribution: item.contribution,
            time: e.meetingDate ? moment(e.meetingDate).format('YYYY-MM') : ''
            // score:
          });
        });
      } else {
        this.data.push({
          ...e,
          time: e.meetingDate ? moment(e.meetingDate).format('YYYY-MM') : '',
          companyRowSpan: 1
        });
      }
    });
  }

  async getColumns() {
    await this.getDepartments();
    this.columns = [
      {
        title: '项目名称',
        key: 'companyName',
        width: '100',
        fixed: 'left',
        customRender: (value, row, index) => {
          const obj = {
            children:
              value.departments.length > 0 ? (
                <a-popover placement="topLeft">
                  <template slot="content">
                    {value.departments.map(item =>
                      item !== 256 && item !== 512 ? (
                        <span>
                          {this.roleMap[item]}-{this.departmentMap[item]}&nbsp;&nbsp;
                        </span>
                      ) : (
                        <span></span>
                      )
                    )}
                  </template>
                  {value.companyName}
                </a-popover>
              ) : (
                <div>{value.companyName}</div>
              ),
            attrs: {}
          };
          if (value.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = value.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: '轮次',
        dataIndex: 'roundName',
        key: 'roundName',
        width: '80px',
        // scopedSlots: {
        //   customRender: 'roundName'
        // },
        // customCell: (record, index) => {
        //   console.log(record);
        //   console.log(index);
        //   const obj = {
        //     attrs: {}
        //   };
        //   if (record.companyRowSpan === 0) {
        //     obj.attrs['colSpan'] = 0;
        //   } else {
        //     obj.attrs['rowSpan'] = record.companyRowSpan;
        //
        //   }
        //   // obj.attrs['colSpan'] = 1;
        //   return obj;
        // },
        customRender: (value, row, index) => {
          const obj = {
            children: (
              <a-popover placement="topLeft">
                <template slot="content">
                  https://applink.feishu.cn/client/mini_program/open?mode=sidebar-semi&appId={this.appId}&path=pages/quality/comment?param={row.id}$256
                </template>
                {value}轮
              </a-popover>
            ),
            // children: value + '轮',
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: '上会分类',
        dataIndex: 'meetingCategory',
        key: 'meetingCategory',
        width: '100px',
        customRender: (value, row, index) => {
          const obj = {
            children: this.meetingCategoryMap[value],
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: '上会目的',
        dataIndex: 'meetingGoal',
        width: '150px',
        key: 'meetingGoal',
        customRender: (value, row, index) => {
          const obj = {
            children: this.meetingGoalMap[value],
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: '上会时间',
        dataIndex: 'time',
        key: 'time',
        width: '80px',
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: 'DL',
        dataIndex: 'dlName',
        key: 'dlName',
        width: '60px',
        customRender: (value, row, index) => {
          const obj = {
            children: value,
            attrs: {}
          };
          if (row.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = row.companyRowSpan;
          }
          return obj;
        }
      },
      {
        title: '成员',
        dataIndex: 'nickname',
        key: 'nickname'
      },
      {
        title: '角色',
        dataIndex: 'role',
        key: 'role',
        customRender: val => {
          return this.roleMap[val];
        }
      },
      {
        title: 'leader评语',
        dataIndex: 'leaderEvaluate',
        key: 'leaderEvaluate',
        scopedSlots: { customRender: 'leaderEvaluate' }
      },
      {
        title: '贡献程度（自述）',
        dataIndex: 'contributeLevel',
        key: 'contributeLevel',

        customRender: val => {
          return this.contributeLevalMap[val];
        }
      },
      {
        title: 'contribution简述（自述）',
        dataIndex: 'contribution',
        key: 'contribution',
        scopedSlots: { customRender: 'contribution' }
      },
      {
        title: '打分人',
        // dataIndex: 'scorers',
        key: 'scorers',
        width: '80px',
        scopedSlots: {
          customRender: 'scorers'
        },
        customCell: (scorer, rowIndex) => {
          const obj = {
            attrs: {}
          };
          obj.attrs['colSpan'] = 3;
          return obj;
        }
      },
      {
        title: '得分',
        key: 'score',
        width: '50px',
        customRender: (data, row, index) => {
          const obj = {
            attrs: {}
          };
          obj.attrs['colSpan'] = 0;
          return obj;
        }
      },
      {
        title: '评语',
        key: 'comment',
        width: '200px',
        customRender: (data, row, index) => {
          const obj = {
            attrs: {}
          };
          obj.attrs['colSpan'] = 0;
          return obj;
        }
      }
    ];
    if (this.permissions['hasScoreGroup']) {
      this.columns.push({
        title: '操作',
        key: 'action',
        fixed: 'right',
        customRender: (value, row, index) => {
          const obj = {
            children:
              value.completeStatus === 2 || value.completeStatus === 1 ? (
                <a-button type="link" class="action" onClick={this.showScoreModal.bind(this, value)}>
                  发起打分
                </a-button>
              ) : (
                <a-button type="link" class="action" disabled={true} onClick={this.showScoreModal.bind(this, value)}>
                  发起打分
                </a-button>
              ),
            attrs: {}
          };
          if (value.companyRowSpan === 0) {
            obj.attrs['rowSpan'] = 0;
          } else {
            obj.attrs['rowSpan'] = value.companyRowSpan;
          }
          return obj;
        }
      });
    }
  }

  handleSearch() {
    this.page = 1;
    this.getList();
  }

  filterChange(key) {
    this.filterNow = key;
    this.page = 1;
    this.getList();
  }

  async urgeCompany() {
    try {
      this.loading = true;
      let res = await qualityCollection();
      this.loading = false;
      if (res.code === 200) {
        this.$message.success('催收成功');
      } else {
        this.$message.error('催收失败');
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }

  onChange(page, pageSize) {
    this.page = page;
    this.getList();
  }

  async showScoreModal(data) {
    try {
      this.showModal = true;
      this.companyObj = data;
      let res = await queryAllMember({ id: this.companyObj['id'] });
      if (res.code === 200) {
        // let scorer: any[] = [];
        let scored: any[] = [];
        this.totalList = res.data.map(_ => {
          return {
            id: _.userId,
            nickname: _.nickname
          };
        });
        res.data.forEach(_ => {
          if (_.role === 256) {
            scored.push({
              id: _.userId,
              nickname: _.nickname
            });
          }
        });
        if (scored.length > 0) {
          this.scoreList.push({ scorer: [{ id: data.dl, nickname: data.dlName }], scored: scored });
        }
        this.scoreList.push({ scorer: [], scored: [] });
      }
    } catch (err) {
      console.log(err);
    }
  }

  addCombination() {
    this.scoreList.push({ scorer: [], scored: [] });
  }

  deleteGroup(index) {
    this.scoreList.splice(index, 1);
  }

  chooseScorerId(index, val) {
    this.$set(this.scoreList[index], 'scorer', val);
  }

  delScorerId(index, val) {
    const item = this.scoreList[index];
    item.scorer = item.scorer.filter(_ => _.id !== val.id);
  }

  chooseScoredId(index, val) {
    this.$set(this.scoreList[index], 'scored', val);
  }

  delScoredId(index, val) {
    const item = this.scoreList[index];
    item.scored = item.scored.filter(_ => _.id !== val.id);
  }

  async initiateScore() {
    try {
      let group = this.scoreList
        .filter(_ => {
          return _.scorer.length > 0 && _.scored.length > 0;
        })
        .map(_ => {
          let judges = _.scorer.map(e => {
            return e.id;
          });
          let contributor = _.scored.map(e => {
            return e.id;
          });
          return {
            judges: judges,
            contributor: contributor
          };
        });
      let res = await createScoreGroup({ id: this.companyObj['id'], group: group });
      if (res.code === 200) {
        this.$message.success('success');
        this.closeCreateModal();
        this.page = 1;
        this.getList();
      }
    } catch (err) {
      console.log(err);
    }
  }

  closeCreateModal() {
    this.showModal = false;
    this.companyObj = {};
    this.scoreList = [];
  }

  copy(id) {
    let url = `https://applink.feishu.cn/client/mini_program/open?appId=${this.appId}&path=pages/quality/score?id=${id}`;
    let oInput = document.createElement('input');
    oInput.value = url;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象;
    document.execCommand('Copy');
    this.$message.success('复制成功');
  }
}
export default QualityManage;
